import React from 'react';

// src/components/Layout/Footer.js
export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const smsMessage = encodeURIComponent('Hi Cassidy! I would love to book a photography session.');

  return React.createElement(
    'footer',
    {
      className: 'bg-black py-8'
    },
    React.createElement(
      'div',
      {
        className: 'max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center'
      },
      React.createElement(
        'div',
        {
          className: 'flex justify-center space-x-6 mb-4'
        },
        React.createElement(
          'a',
          {
            href: 'https://www.instagram.com/cassidysullivanphotography/',
            target: '_blank',
            rel: 'noopener noreferrer',
            'aria-label': 'Visit Cassidy Sullivan Photography on Instagram',
            className:
              'inline-flex h-11 w-11 items-center justify-center rounded-full text-gray-400 transition-colors hover:bg-white/10 hover:text-teal-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-400 focus-visible:ring-offset-2 focus-visible:ring-offset-black'
          },
          React.createElement(
            'svg',
            {
              className: 'h-6 w-6',
              viewBox: '0 0 24 24',
              fill: 'currentColor',
              'aria-hidden': 'true'
            },
            React.createElement('path', {
              d: 'M7.75 2h8.5A5.75 5.75 0 0 1 22 7.75v8.5A5.75 5.75 0 0 1 16.25 22h-8.5A5.75 5.75 0 0 1 2 16.25v-8.5A5.75 5.75 0 0 1 7.75 2zm0 1.5A4.25 4.25 0 0 0 3.5 7.75v8.5A4.25 4.25 0 0 0 7.75 20.5h8.5a4.25 4.25 0 0 0 4.25-4.25v-8.5A4.25 4.25 0 0 0 16.25 3.5h-8.5zM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 1.5A3.5 3.5 0 1 0 12 15.5 3.5 3.5 0 0 0 12 8.5zm5.25-2a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5z'
            })
          )
        ),
        React.createElement(
          'a',
          {
            href: 'https://www.facebook.com/CSullivanPortraits/',
            target: '_blank',
            rel: 'noopener noreferrer',
            'aria-label': 'Visit Cassidy Sullivan Photography on Facebook',
            className:
              'inline-flex h-11 w-11 items-center justify-center rounded-full text-gray-400 transition-colors hover:bg-white/10 hover:text-teal-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-400 focus-visible:ring-offset-2 focus-visible:ring-offset-black'
          },
          React.createElement(
            'svg',
            {
              className: 'h-6 w-6',
              viewBox: '0 0 24 24',
              fill: 'currentColor',
              'aria-hidden': 'true'
            },
            React.createElement('path', {
              d: 'M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.49-3.88 3.77-3.88 1.09 0 2.23.19 2.23.19v2.46h-1.25c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.44 2.89h-2.34v6.99A10 10 0 0 0 22 12z'
            })
          )
        ),
        React.createElement(
          'a',
          {
            href: `sms:+16069226307?body=${smsMessage}`,
            'aria-label': 'Send Cassidy Sullivan Photography a text message',
            className:
              'inline-flex h-11 w-11 items-center justify-center rounded-full text-gray-400 transition-colors hover:bg-white/10 hover:text-teal-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-400 focus-visible:ring-offset-2 focus-visible:ring-offset-black'
          },
          React.createElement(
            'svg',
            {
              className: 'h-6 w-6',
              viewBox: '0 0 24 24',
              fill: 'none',
              stroke: 'currentColor',
              'aria-hidden': 'true'
            },
            React.createElement('path', {
              d: 'M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z'
            })
          )
        ),
        React.createElement(
          'a',
          {
            href: 'mailto:cassidy@cassidysullivanphotography.com',
            'aria-label': 'Email Cassidy Sullivan Photography',
            className:
              'inline-flex h-11 w-11 items-center justify-center rounded-full text-gray-400 transition-colors hover:bg-white/10 hover:text-teal-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-400 focus-visible:ring-offset-2 focus-visible:ring-offset-black'
          },
          React.createElement(
            'svg',
            {
              className: 'h-6 w-6',
              viewBox: '0 0 24 24',
              fill: 'none',
              stroke: 'currentColor',
              'aria-hidden': 'true'
            },
            React.createElement('path', {
              d: 'M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z'
            }),
            React.createElement('polyline', { points: '22,6 12,13 2,6' })
          )
        )
      ),
      React.createElement(
        'p',
        {
          className: 'text-sm text-gray-300 mb-2'
        },
        React.createElement(
          'a',
          {
            href: 'tel:+16069226307',
            className: 'hover:text-teal-400 transition-colors'
          },
          'Call/Text: (606) 922-6307'
        ),
        ' • ',
        React.createElement(
          'a',
          {
            href: 'mailto:cassidy@cassidysullivanphotography.com',
            className: 'hover:text-teal-400 transition-colors'
          },
          'cassidy@cassidysullivanphotography.com'
        )
      ),
      React.createElement('p', { className: 'text-gray-400' }, `© ${currentYear} Cassidy Sullivan Photography, a Berry Holdings LLC company. All rights reserved.`)
    )
  );
};
